exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i {\n  color: red;\n  font-weight: bold;\n}\n\n.inbtn1 {\n  position: absolute;\n  margin-top: -21px;\n  font-size: 12px;\n  right: 0;\n  margin-right: 40px\n}\n\n.selectedclass {\n  background-color: #8c8e8d !important;\n  color: #ffffff !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/lazy-modules/+private-page/inventory/products/product-grp/product/product.component.css
// module id = ../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/product/product.component.css
// module chunks = main